import { faBan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Text } from '@modusign/design-system';

import DocumentStatus from '../../types/DocumentStatus';

interface DocumentStatusBadgeProps {
  status: DocumentStatus;
}

export default function DocumentStatusBadge({ status }: DocumentStatusBadgeProps) {
  switch (status) {
    case 'ABORTED':
      return (
        <Text
          color="textNeutralLight"
          display="flex"
          fontSize="sm"
          fontWeight="medium"
          sx={{ alignItems: 'center' }}
        >
          <FontAwesomeIcon
            icon={faBan}
            style={{ marginRight: '6px', height: '11px', width: '11px' }}
          />
          계약 중단
        </Text>
      );

    case 'EFFECTIVE':
      return (
        <Text
          color="textPositiveBase"
          display="flex"
          fontSize="sm"
          fontWeight="medium"
          sx={{ alignItems: 'center' }}
        >
          <Box as="svg" fill="currentColor" height="9" mr={2} viewBox="0 0 10 10" width="9">
            <circle cx="5" cy="5" r="5" />
          </Box>
          계약 이행 중
        </Text>
      );

    case 'EXPIRED':
      return (
        <Text
          color="textNeutralLight"
          display="flex"
          fontSize="sm"
          fontWeight="medium"
          sx={{ alignItems: 'center' }}
        >
          <Box as="svg" fill="currentColor" height="9" mr={2} viewBox="0 0 10 10" width="9">
            <circle cx="5" cy="5" r="5" />
          </Box>
          계약 종료
        </Text>
      );
    default:
      return null;
  }
}
